import type { AnimationDefinition } from "motion/react";

/**
 * True iff `definition` is an `animate` target that ends at opacity 0 (i.e.
 * a fade-out exit). Useful inside `onAnimationComplete` to filter out
 * non-exit animation settles — layout springs, sibling shifts, in-flight
 * variant transitions — when you need to fire a one-shot post-exit callback
 * and a spurious early fire would yank the element mid-animation.
 */
export function isExitTargetDefinition(definition: AnimationDefinition): boolean {
  return (
    typeof definition === "object" &&
    definition !== null &&
    "opacity" in definition &&
    definition.opacity === 0
  );
}
